import { makeStyles, tokens } from '@coreai/fluentui-react';

/**
 * Toolbar that sits above a monitoring list (e.g. above run cards or trigger
 * history rows): count on the left, custom + standard actions (refresh /
 * export) on the right.
 */
export const useMonitoringListHeaderStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: tokens.spacingVerticalM,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    marginBottom: tokens.spacingVerticalS,
  },
  count: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
  },
  countNumber: {
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
  },
  refreshIconSpinning: {
    animationName: {
      from: { transform: 'rotate(0deg)' },
      to: { transform: 'rotate(360deg)' },
    },
    animationDuration: tokens.durationUltraSlow,
    animationIterationCount: 'infinite',
    animationTimingFunction: tokens.curveLinear,
    '@media (prefers-reduced-motion: reduce)': {
      animationDuration: '0.01ms',
      animationIterationCount: 1,
    },
  },
});
